import { formatHtml } from "@trumpf/ux.common-storybook";
import {
    dummyContactTeaser,
    dummyContactTeaserUnit,
    dummyContactTeaserExtended,
    TeaserContactTemplate,
    TeaserContactExtendedTemplate,
    TeaserContactListTemplate,
    TeaserContactUnitTemplate,
} from "./teaser-contact.templates";

export default {
    title: "Website/Partial Templates/Teaser/Contact",
    render: TeaserContactTemplate.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const Default = {
    args: {
        ...dummyContactTeaser,
    },
};

export const ContactUnit = {
    render: TeaserContactUnitTemplate.bind({}),
    args: {
        ...dummyContactTeaserUnit,
    },
};

export const ContactExtended = {
    render: TeaserContactExtendedTemplate.bind({}),
    args: {
        ...dummyContactTeaserExtended,
    },
};

export const List = {
    render: TeaserContactListTemplate.bind({}),
};
